import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faTwitter,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import EvolveLogo from "../../assets/img/evolve.png";

const Footer = () => {
  const [selectedType, setSelectedType] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedType = JSON.parse(sessionStorage.getItem("visual_type"));
    if (storedType) {
      setSelectedType(storedType);
    } else {
      setSelectedType("today");
      sessionStorage.setItem("visual_type", JSON.stringify("today"));
    }
  }, [location.pathname]);

  const handleVisualType = (type) => {
    sessionStorage.setItem("visual_type", JSON.stringify(type));
    setSelectedType(type);
    if (type === "today") {
      navigate("/Visualization");
    } else if (type === "tomorrow") {
      navigate("/CancerTomorrow");
    } else {
      navigate("/CancerOvertime");
    }
  };

  return (
    <footer className="footer-section mt-auto">
      <div className="container-fluid bg-primary">
        <div className="container py-3 text-white">
          <div className="row footer-content">
            {/* Links Section */}
            <div className="col-12 col-md-3 footer-column mb-4 mb-md-0">
              <h6 className="footer-title pb-3">QUICK LINKS</h6>
              <nav className="nav flex-column">
                <Link className="footer-link" to={"/"}>
                  Home
                </Link>
                <Link className="footer-link" to={"/pages/contact_us"}>
                  Contact Us
                </Link>
                <Link className="footer-link" to={"/pages/terms_condition"}>
                  Terms & Conditions
                </Link>
                <Link className="footer-link" to={"/pages/privacy_policy"}>
                  Privacy Policy
                </Link>
              </nav>
            </div>

            {/* About Section */}
            <div className="col-12 col-md-3 footer-column mb-4 mb-md-0">
              <h6 className="footer-title pb-3">ABOUT US</h6>
              <p className="footer-text lh-lg mb-2">
                Tamil Nadu – Cancer Registry Statistics (TN-CReSt) is an online
                tool meant for Analytics for Action Against Cancer.
              </p>
              <Link className="footer-link" to={"/pages/about_us"}>
                Learn More →
              </Link>
            </div>

            {/* Data Visualization Section */}
            <div className="col-12 col-md-3 footer-column mb-4 mb-md-0">
              <h6 className="footer-title pb-3">DATA VISUALIZATION</h6>
              <ul className="nav flex-column">
                <li
                  className={`footer-link-item ${
                    selectedType === "today" ? "active" : ""
                  }`}
                  onClick={() => handleVisualType("today")}
                >
                  Recent Cancer Statistics
                </li>
                <li
                  className={`footer-link-item ${
                    selectedType === "overtime" ? "active" : ""
                  }`}
                  onClick={() => handleVisualType("overtime")}
                >
                  Trend of Cancer Incidence
                </li>
                <li
                  className={`footer-link-item ${
                    selectedType === "tomorrow" ? "active" : ""
                  }`}
                  onClick={() => handleVisualType("tomorrow")}
                >
                  Cancer Projection
                </li>
              </ul>
            </div>

            {/* Social Section */}
            <div className="col-12 col-md-3 footer-column">
              <h6 className="footer-title pb-3 text-md-center">
                CONNECT WITH US
              </h6>
              <div className="social-links d-flex justify-content-start justify-content-md-center gap-3">
                <a
                  href="https://www.youtube.com/channel/UClgI0nJ3FZr9xOrnqU4YlBA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="YouTube"
                >
                  <FontAwesomeIcon icon={faYoutube} size="lg" />
                </a>
                <a
                  href="https://x.com/ci_wia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Twitter"
                >
                  <FontAwesomeIcon icon={faTwitter} size="lg" />
                </a>
                <a
                  href="https://www.facebook.com/Cancerinstitutewiaadyarchennai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Facebook"
                >
                  <FontAwesomeIcon icon={faFacebook} size="lg" />
                </a>
              </div>
            </div>
          </div>

          {/* Copyright */}
          {/* Added powered by on 06-03-2026 by muthu */}
          <hr className="my-3 border-white-50" />
          <div className="row align-items-center">
            <div className="col-md-4"></div>

            <div className="col-md-4 text-center">
              <p className="footer-copyright mb-0">
                © {new Date().getFullYear()} Tamil Nadu Cancer Registry
                Statistics. All rights reserved.
              </p>
            </div>

            <div className="col-md-4 text-center text-md-end mt-2 mt-md-0">
              <span className="footer-copyright footer-powered-by">
                Powered By
              </span>
              <a
                href="https://evolve.co.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-copyright footer-powered-by text-decoration-none"
              >
                <img
                  src={EvolveLogo}
                  alt="Evolve Bizcon"
                  className="footer-powered-by-logo me-1"
                />
                Evolve Bizcon
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
